import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DistributorIdFormatPipe } from "../../common/pipes/distributor-id-format.pipe";
import { CookieService } from 'ngx-cookie-service';
import { ReportNameConstants } from '../constants/report-names.constants';
import { ReportTypeConstants } from '../constants/report-type.constants';
import { MemberTypeEnum } from '../enums/member-type.enum';
import { ReportTypeEnum } from '../enums/report-type.enum';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { DownlineMapComponent } from './downline-map.component';
import { UplineReportComponent } from './reports/upline-report.component';
import { SSO } from '../../sso/sso.constants';
import { environment } from '../../../environments/environment';


@Component({
    selector: 'app-reports',
    templateUrl: '../templates/template1/views/master-reports.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/master-reports.component.less'
    ],
    providers: [DistributorIdFormatPipe, DecimalPipe]

})
export class MasterReportsComponent implements OnInit {

    @Input() distributorInfo: DistributorInfo;
    @Input() fboid: string;
    @Input() homeCountryInfo: string;
    @Input() operatingCountryInfo: string;
    reportsFormGroup:FormGroup;
    memberTypeEnum = MemberTypeEnum;
    reportTypeEnum = ReportTypeEnum;
    reportNameConstants = ReportNameConstants;
    reportTypeConstants = ReportTypeConstants;
    reportNames : Array<string> = [];
    selectedReportType:number = 1;
    selectedReportName:string = this.reportNameConstants.ViewIncentives;
    cookieService: CookieService = new CookieService(document);
    @ViewChild(UplineReportComponent) uplineReportComponent: UplineReportComponent;
    @ViewChild(DownlineMapComponent) downlineMapComponent: DownlineMapComponent;
    
    constructor(       
        private _formBuilder: FormBuilder   ,
       
    ) { }

    ngOnInit(): void {
      this.reportsFormGroup = 
        this._formBuilder.group({
        reportType:[''],
        reportName:['']
       })
     this.assignReportNames();
    }

    assignReportNames(){
        this.cookieService.set(SSO.AuthorizedUser_UAT,environment.disableVpnPin === true ? "true" : "false",null, environment.cookiePath, environment.cookieDomain);
        this.reportNames = [];
        if(this.selectedReportType=== ReportTypeEnum.AgentPortalFBOReports){
            this.reportNames.push(this.reportNameConstants.ViewIncentives);
            this.reportNames.push(this.reportNameConstants.DownlineReport);
            this.reportNames.push(this.reportNameConstants.DownlineMapReport);
            this.reportNames.push(this.reportNameConstants.UplineReport);

            this.selectedReportName = this.reportNameConstants.ViewIncentives;
        } 
        else if(this.selectedReportType===ReportTypeEnum.FBOReports){
            this.reportNames.push(this.reportNameConstants.OrderHistory);
            this.reportNames.push(this.reportNameConstants.MyVolume);
            this.reportNames.push(this.reportNameConstants.TotalCCVolumeTrend);
            this.reportNames.push(this.reportNameConstants.MyDownlineVolume);
            this.reportNames.push(this.reportNameConstants.BonusRecapMyEarnings);
            this.reportNames.push(this.reportNameConstants.MyCustomers);
            this.reportNames.push(this.reportNameConstants.PersonallySponsoredFBOs);

            this.selectedReportName = this.reportNameConstants.OrderHistory;
        }
        else if(this.selectedReportType===ReportTypeEnum.FBOAccountPortalWidgets){
            this.reportNames.push(this.reportNameConstants.YourBusiness);
            this.reportNames.push(this.reportNameConstants.NextLevelGoal);
            this.reportNames.push(this.reportNameConstants.FourCCActive);
            this.reportNames.push(this.reportNameConstants.LeadershipBonus);

            this.selectedReportName = this.reportNameConstants.YourBusiness;
        }
    }

   
}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/master-reports.component.ts